<template>
  
   <div style="width:98%;margin:0 auto;margin-top:10px">
 
    <!-- 封装弹框 -->
   
              <el-tabs v-model="activeIndex" @tab-click="handleTabClick" type="border-card">

                <el-tab-pane :label="$t('msg.회원')" name="tab1">
                   <div  class="card-header d-flex align-items-center" style="padding:0 8px">
                    <div>{{$t('msg.회원정보')}} 
                      :
                      <template v-if="form.mem_lev<=6 && form.m_code!=form.mem_id"><el-button type="text"   @click="openId(form.m_code)"> {{form.m_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=5 && form.s_code!=form.mem_id"><el-button type="text"   @click="openId(form.s_code)">{{form.s_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=4 && form.b_code!=form.mem_id"><el-button type="text"   @click="openId(form.b_code)">{{form.b_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=3 && form.a_code!=form.mem_id"><el-button type="text"   @click="openId(form.a_code)"> {{form.a_code}}</el-button> > </template>
                      <template v-if="form.mem_lev<=2 && form.c_code!=form.mem_id"><el-button type="text"   @click="openId(form.c_code)"> {{form.c_code}} </el-button> >  </template>

                      

                      <template  v-for="(item,index) in form.memlist"  ><el-button  type="text"  @click="openId(item)">{{item}}</el-button> > </template>


                      <!--<template v-if="form.mem_lev==1"><el-button type="text"  @click="openId(form.mem_id,'tab1')">{{form.mem_id}}</el-button></template>-->
                      </div>
                    <div class="ml-auto">
                     
                     


                     

                  <template v-if="form.user_type=='user'">
                  <span class="mr-1">API</span>
                   
                   <el-select :placeholder="$t('status.선택')" v-model="form.api_join" size="mini" style="width:80px;" class="mr-1">
                      <el-option
                      v-for="item in optionsApi"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  </template>

                
                  
                
                    </div>
                  </div> 
                  <el-form ref="form" :model="form" label-width="100px" v-loading="formLoading">
              <table class="table table-bordered myTable myTableNew">
                <tr>
                  <td width="50%">
                   
                     <el-form-item :label="$t('msg.아이디')" class="mb-0  formItem layerItem">
                  {{form.mem_id}}<span class="ml-1">{{form.id_txt}}</span>
                  <el-button type="primary" size="mini" class="ml-1" plain @click="add" style="padding:5px 6px">{{$t('msg.쪽지')}}</el-button>
                  <el-button type="primary" size="mini" class="ml-1" @click="bonOpen(1,form.mem_id,'1')" style="padding:5px 6px">{{$t('tableText.충환전')}}</el-button>
                  <el-button type="danger" size="mini" class="ml-1" plain @click="couponOpen(form.mem_id)" style="padding:5px 6px">{{$t('newAdd.쿠폰')}}</el-button>
                 
                     
                </el-form-item>
                  </td>
                  <td style="position: relative;">
                    <div class="d-flex">
                     <el-form-item  class="mb-0 formItem layerItem" :label="$t('msg.등급')">
                     
                   <el-select :placeholder="$t('status.선택')" v-model="form.memState" size="mini" style="width:55px;" class="mr-1">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="color:#999">{{$t('tableText.상태')}}</span>
                  <el-select :placeholder="$t('status.선택')" v-model="form.mem_status" size="mini" style="width:55px" class="ml-1">
                    <el-option
                    v-for="item in statusoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                  </el-select>
                  <template v-if="form.pasing=='1' && form.mem_id==form.c_code">
                 <span class="mr-1 ml-1">{{$t('msg.파싱')}}</span>
                  <el-checkbox true-label="1" false-label="0" v-model="form.mem_sms" style="margin-right:0px !important"></el-checkbox></template>


                  <span class="mr-1 ml-1">{{$t('msg.머니이동차단')}}</span>
                  <el-checkbox true-label="1" false-label="0" v-model="form.trans_black" style="margin-right:0px !important"></el-checkbox>

                  </el-form-item>
                 
                </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item  class="mb-0 formItem layerItem" :label="$t('tableText.잔액')">
                    
                    <template v-if="form.sitetype=='4' && this.sim!='1'">
                      <div class="d-flex">

                         <div class="mr-2">{{$t('msg.알잔액')}}:{{formatMoney(form.mem_cash)}}</div>

                          <div>
                          {{$t('msg.카슬머니')}}:<span class="text-primary" style="cursor:pointer" @click="getm">{{formatMoney(form.api_money)}}</span>

                          <el-button type="default" :title="$t('msg.카슬머니갱신')"  size="mini" style="padding:2px;margn: 0;" class="mr-1" icon="el-icon-refresh" @click="apiMoney('')"></el-button>
                         </div>
                         <div >
                            <template v-if="form.sitetype=='1' || form.sitetype=='4'">{{$t('msg.롤링')}}:</template><span class="ml-1 mr-1 text-primary">{{formatMoney(form.mem_eventmoney)}}</span>
                         </div>
                         
                          
                         
                      </div>
                      </template>

                   
                  
                  </el-form-item>

              


                  </td>
                  <td>
                    <el-form-item label="파트너" class="mb-0 formItem layerItem">
                     
                      
                 

                     <span style="color:#999;" class="ml-1">{{$t('msg.부본')}}</span> <span class="text-danger ml-1 " @click="openId(form.b_code)" style="cursor:pointer">{{form.b_code}}</span>  <span style="color:#999"  class="">{{$t('msg.총판')}}</span> <span class="text-primary " @click="openId(form.a_code)"style="cursor:pointer">{{form.a_code}}</span>
                      <template v-if="form.sitetype=='1' || form.sitetype=='2' || form.sitetype=='3'"><span style="color:#999" class="mr-1">{{$t('msg.추천인')}}</span> {{form.m_cp}}</template>
                      <template v-if="form.sitetype==='4'"><span style="color:#999" class="">{{$t('msg.매장')}}</span><span @click="openId(form.c_code)" class="text-primary" style="cursor:pointer"> {{form.c_code}}</span></template>
                   
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item label="비번"  class="mb-0 formItem layerItem">
                  
                       <el-input v-model="form.mem_pw" style="width:40%"></el-input>
                      <span class="ml-2"> {{$t('tableText.출금비번')}}: </span><el-input v-model="form.mem_jumin" class="w-25"></el-input>

                    </el-form-item>
                 
                  </td>
                 
                  <td>
                    <el-form-item label="경로" class="mb-0  formItem layerItem">
                      <span style="color:#999" class="ml-1">{{$t('msg.가입')}}:</span><span class="ml-2">{{form.ref}}</span>
                      <span style="color:#999" class="ml-1">{{$t('msg.접속')}}:</span><span class="ml-2">{{form.mem_email}}</span>

                       <template v-if="form.sitetype=='4' && form.c_code==form.mem_id">
                       <span style="color:#999" class="ml-1" >{{$t('msg.가입코드')}}:</span>
                       <span class="ml-2"><el-input v-model="form.reg_code" style="width:80px;" class="mr-1" size="mini"></el-input></span>
                       </template>
                   
                  </el-form-item>

                  </td>
                </tr>
                 <tr>
                   <td>

                     <el-form-item :label="$t('msg.닉네임')" class="mb-0 formItem layerItem">
                        <div class="d-flex">
                      <el-input v-model="form.mem_name" class="w-75"></el-input>
                      <el-color-picker v-model="form.color" size="mini" class="ml-2" style="margin-top: 3px;"></el-color-picker>
                    </div>
                   </el-form-item>
                  
                  </td>
                   <td>
                      <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem layerItem">
                    <el-input v-model="form.mem_hp" style="width:40%;margin-right:3px"></el-input>
                 </el-form-item> 
                  </td>
                 
                </tr>
                  
             
                 <tr v-if="form.sitetype==='1' || form.sitetype==='3' ">
                  <td>
                     

                              <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code || form.mem_id===form.s_code || form.mem_id===form.m_code">
                               <el-form-item :label="$t('msg.롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom" style="width:30px;" class="mr-1"></el-input>
                                <span  class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom" style="width:30px;"></el-input> 
                                <span  class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_recom_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_recom_s" style="width:30px;"></el-input>
                              </el-form-item>
                           
                            
                              
                            </template>

                              <template v-else="">
                               <el-form-item :label="$t('msg.롤링')"  class="mb-0 float-left formItem layerItem">
                                <span  class="mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing" style="width:30px;"></el-input>
                                <span class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group" style="width:30px;" ></el-input><span class="ml-1 mr-1">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_s" style="width:30px;"></el-input><span class="ml-1 mr-1">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                              </el-form-item>                                 
                                                       
                               </template>

                  
                  </td>
                  <td>
                    <template v-if="form.out_bet_sadari_g==='100' " >
                     <el-form-item :label="$t('msg.바치기')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.out_bet_power" style="width:40px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.out_bet_power_g" style="width:40px;"></el-input> <span  class="ml-2 mr-2">{{$t('msg.사다리')}}:</span><el-input v-model="form.out_bet_sadari" style="width:40px;"></el-input>
                     </el-form-item>
                     </template>

                     <template v-if="form.bg==='1' " >

                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                               <el-form-item :label="$t('msg.보글롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class=" mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom1" style="width:30px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom1" style="width:30px;"></el-input> <span  class="ml-2 mr-2">{{$t('msg.사일')}} :</span><el-input v-model="form.event_loing_recom_s1" style="width:30px;"></el-input><span  class="ml-2 mr-2">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_recom_s1" style="width:30px;"></el-input>
                              </el-form-item>
                           
                            
                              
                            </template>

                              <template v-else="">
                               <el-form-item  :label="$t('msg.보글롤링')" class="mb-0 float-left formItem layerItem">
                                <span  class="mr-2">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing1" style="width:30px;"></el-input>
                                <span class="ml-2 mr-2">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group1" style="width:30px;" ></el-input><span class="ml-2 mr-2">{{$t('msg.사일')}}:</span><el-input v-model="form.event_loing_s1" style="width:30px;"></el-input><span class="ml-2 mr-2">{{$t('msg.사조')}}:</span><el-input v-model="form.event_loing_group_s1" style="width:30px;"></el-input>
                              </el-form-item>
                              
                              </el-form-item>                                 
                                                       
                               </template>
                                </template>
                  </td>
                  
                </tr>
                 <tr v-if="form.sitetype==='4'">
                  <td colspan="1">
                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code || form.mem_id===form.s_code || form.mem_id===form.m_code">
                              <el-form-item label="롤링설정" class="mb-0 float-left formItem layerItem">
                              <span style="" class="mr-1">{{$t('msg.바카라')}}:</span><el-input v-model="form.event_loing_recom_e" style="width:30px;"></el-input>
                              <span style="" class="mr-1">{{$t('msg.슬롯')}}:</span><el-input v-model="form.event_loing_recom_slot" style="width:30px;"></el-input>
                               <template v-if="this.power=='1'">
                              <span  class=" mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing_recom" style="width:30px;" class="mr-1"></el-input>
                              <span  class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group_recom" style="width:30px;"></el-input> 
                              </template>
                              </el-form-item>
                              
                            </template>

                              <template v-else="">
                               <el-form-item label="롤링설정"  class="mb-0 float-left formItem layerItem">
                                <span style="" class=" mr-1">{{$t('msg.바카라')}}:</span><el-input v-model="form.event_loing_e" style="width:30px;"></el-input>
                                <span style="" class="mr-1">{{$t('msg.슬롯')}}:</span><el-input v-model="form.event_loing_slot" style="width:30px;"></el-input>
                                <template v-if="this.power=='1'">
                                <span  class="mr-1">{{$t('msg.일반')}}:</span><el-input v-model="form.event_loing" style="width:30px;"></el-input>
                                <span class="ml-1 mr-1">{{$t('msg.조합')}}:</span><el-input v-model="form.event_loing_group" style="width:30px;" ></el-input>
                                </template>
                              </el-form-item>                             
                                                       
                               </template>
                  </td>

                  <td>
                     
                            

                             
                              <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code || form.mem_id===form.s_code || form.mem_id===form.m_code">
                               <el-form-item :label="$t('nav.이벤트')" class="mb-0 float-left formItem layerItem">
                               
                                <span  class="ml-1 mr-1">{{$t('newAdd.첫충')}}:</span><el-input v-model="form.event_loing_recom_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('newAdd.재충')}}:</span><el-input v-model="form.event_loing_group_recom_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('newAdd.한도')}}:</span><el-input v-model="form.event_pro_boat" style="width:30px;"></el-input>
                              </el-form-item>
                           
                            
                              
                            </template>

                              <template v-else="">
                               <el-form-item :label="$t('nav.이벤트')"  class="mb-0 float-left formItem layerItem">
                              </el-input><span class="ml-1 mr-1">{{$t('newAdd.첫충')}}:</span><el-input v-model="form.event_loing_s" style="width:30px;"></el-input><span class="ml-1 mr-1">{{$t('newAdd.재충')}}:</span><el-input v-model="form.event_loing_group_s" style="width:30px;"></el-input><span  class="ml-1 mr-1">{{$t('newAdd.한도')}}:</span><el-input v-model="form.event_pro_boat" style="width:80px;"></el-input>
                              </el-form-item>
                              
                              </el-form-item>                                 
                                                       
                               </template>
                           
                  
                  </td>
                  
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.계좌정보')" class="mb-0 formItem layerItem">
                     
                <el-input v-model="form.mem_bankcode" style="width:90px;" placeholder="은행명"></el-input>
                 <el-input v-model="form.mem_bankname" style="width:90px;" placeholder="예금주"></el-input>   
                 <el-input v-model="form.mem_banknum" style="width:196px;" placeholder="계좌번호"></el-input>
                </el-form-item>
               
                  </td>
                  <td>
                     <el-form-item  :label="$t('msg.파싱설정')" class="mb-0 formItem layerItem">
                             
                        <template v-if="form.pasing=='1' && form.mem_id!=form.m_code && form.mem_id!=form.s_code && form.mem_id!=form.b_code && form.mem_id!=form.a_code && form.mem_id!=form.c_code ">
                      
                         <el-radio-group v-model="form.out_bet_power" @change="changeLabel" >
                                    <el-radio :label="'0'" style="">매장따라</el-radio>
                                    <el-radio :label="'1'" style="">개별</el-radio>
                                  </el-radio-group> 
                                 
                           <template v-if="form.out_bet_power=='1' ">
                                      <span class="mr-1 ml-3" style="display:inline-block;height:30px;line-height:30px">파싱</span>
                                   <el-checkbox true-label="1" false-label="0" v-model="form.mem_sms" style="display:inline-block;height:30px !important;line-height:30px !important;margin-right:15px !important"></el-checkbox> 
                           </template>
                                   

                                   <el-radio-group v-if="form.out_bet_power=='1' || form.is_ps=='1'" v-model="form.event_pro" @change="changeLabel1" style="background:#ebebeb !important;padding:5px !important">
                                    <el-radio :label="'0'" style="margin-right:5px !important">올파</el-radio>
                                    <el-radio :label="'1'" style="">정+파</el-radio>
                                  </el-radio-group> 

                         </template>
                                
                            
                </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('tableText.전용가상')"  class="mb-0 formItem layerItem">
                      <el-input v-model="form.mem_zip" placeholder="생년월일" style="width:110px;"></el-input>
                       <el-input v-model="form.ref" style="width:270px;"></el-input>
                    </el-form-item>

                  </td>
                  <td>

                    <el-form-item label="공배팅" class="mb-0 formItem layerItem">
                    <template v-if="form.mem_id === form.c_code" >

                       <span class="ml-1">카공배팅: </span><el-input v-model="form.ca_gong" style="width:60px;"></el-input>
                      <span class="ml-1">슬공배팅: </span><el-input v-model="form.slot_gong" style="width:60px;"></el-input> 
                     </template>
                    </el-form-item> 

                 
                  </td>
                </tr>
                <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td>
                    <div class="d-flex">
                     <el-form-item :label="$t('nav.배팅한도')" class="mb-0 formItem layerItem">
                            <el-input v-model="form.max_bet"></el-input>
                          </el-form-item>
                           <el-form-item v-if="form.sitetype==='2' || form.sitetype==='3'" :label="$t('nav.딜레이')" class="mb-0 formItem layerItem">
                            <el-input v-model="form.t_delay"  style="width: 80px;"></el-input>
                          </el-form-item>
                    </div>
                  </td>
                  <td>
                     <el-form-item :label="$t('nav.적중한도')" class="mb-0 formItem layerItem">
                             <el-select placeholder="선택" v-model="form.m_emoney" size="mini">
                                  <el-option
                                  v-for="item in statusoptions2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select>
                          </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                       <el-form-item  :label="$t('msg.배팅누적')"  class="mb-0 formItem layerItem">
                  <template v-if="form.sitetype!='4'">{{formatMoney(form.mem_all_init)}}</template>
                  <template v-if="form.sitetype=='4'">
                  <span class="ml-1 mr-1">{{$t('nav.카')}}:</span> {{formatMoney(form.mem_all_e)}}
                  <span class="ml-1 mr-1">{{$t('nav.슬')}}:</span> {{formatMoney(form.mem_all_slot)}}
                  <template v-if="this.power=='1'"><span class="ml-1 mr-1">{{$t('nav.파')}}:</span> {{formatMoney(form.mem_all_power)}}</template>

                </template>
                  <!-- <el-button type="default" title="배팅누적리셋" size="mini" style="padding:2px;" class="mr-1" icon="el-icon-refresh" @click="resetMoney(4)"></el-button> -->
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.배팅차단')" class="mb-0 formItem layerItem">
                        <el-select :placeholder="$t('status.선택')" v-model="form.bet_black" style="width:80px">
                            <el-option
                            v-for="item in options1"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                          </el-select>
                     <template v-if="form.sitetype==='1' || form.sitetype==='3'">{{$t('msg.파워')}}<el-checkbox true-label="1" false-label="0" v-model="form.bet_black" style="margin-right:5px;"></el-checkbox></template>
                     
                     <template v-if="form.sitetype==='2' || form.sitetype==='3'"><span style="margin-top:0px;">{{$t('msg.한경')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black1" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일륜')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black2" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일정')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black3" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">{{$t('msg.일경')}}</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black4" style="margin:0 5px;"></el-checkbox></template>
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.입출금')" class="mb-0 formItem layerItem">
                     <span  class="ml-1">입금:</span>
                     <span class="text-danger">{{formatMoney(form.in_money)}}</span>
                     <span  class="ml-1">출금:</span>
                     <span class="ml-2 mr-2 text-primary">{{formatMoney(form.out_money)}}</span> 
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.가입일')" class="mb-0 formItem layerItem">
                      {{(form.mem_regdate).substring(0, 10)}} <span class="ml-1">{{$t('msg.마지막로그인')}}:</span> {{(form.mem_login_date).substring(0, 10)}}
                      </el-form-item>


                  </td>
                </tr>
                  <tr>
                  <td>
                    <div class="d-flex">
                    <el-form-item :label="$t('tableText.알충환')" class="mb-0 formItem layerItem">
                    <span class="ml-1">{{$t('searchText.알충')}}:</span>
                    <span class="text-danger"> {{formatMoney(form.off_in)}}</span>
                    <span class="ml-1">{{$t('searchText.알환')}}:</span>
                    <span class="ml-2 mr-2  text-primary">{{formatMoney(form.off_out)}}</span>
                    </el-form-item>
                     
                    </div>
                  </td>
                  <td>
                   <el-form-item :label="$t('msg.가입IP')" class="mb-0 formItem layerItem">
                          <el-input type="textarea" :rows="1" v-model="form.mem_ip" style="width:120px"></el-input>
                                <span style="" class="ml-1">{{$t('msg.최종IP')}}:</span><el-input type="textarea" :rows="1" v-model="form.logip" style="width:120px">
                                </el-input>
                         
                        </el-form-item>
                   
                    
                  </td>
                </tr>
                  <tr>
                 
                  <td>
                      <el-form-item :label="$t('msg.로그인회수')" class="mb-0 formItem layerItem">
                        {{form.mem_login}} <el-button type="danger" size="mini" style="padding:2px;" class="ml-2 mr-2" :title="$t('msg.로그아웃처리')"  @click="mlogout()">{{$t('msg.팅기기')}}</el-button><!-- <span class="mr-2">중복로그인</span><el-select placeholder="선택" v-model="form.login_more" size="mini" style="width: 80px;">
                                  <el-option
                                  v-for="item in statusoptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select> -->
                               
                      </el-form-item> 
                       
                       
                  </td>
                     <td>
                     <el-form-item label="마지막입출금" class="mb-0 formItem layerItem">
                       <span style="color:#999;" class="ml-1">{{$t('msg.입금')}}:</span>{{form.last_money_date}} <span style="color:#999;" class="ml-1">{{$t('msg.출금')}}:</span>{{form.last_out_money_date}}
                      </el-form-item>
                  </td>
                </tr>
                
                  <tr>
                  <td colspan="2">
                    <el-form-item class="mb-0 formItem layerItem whitelistItem">
                      <template slot="label">
                        <div style="line-height:18px;">
                          <div>화이트아이피</div>
                          <el-popover
                            placement="bottom-start"
                            title="tips"
                            trigger="click"
                            content="여러아이피경우 띠여쓰기 또는 줄내림 또는 콤마로 연결해주세요">
                            <el-button
                              slot="reference"
                              type="text"
                              icon="el-icon-question"
                              style="padding:0;">
                            </el-button>
                          </el-popover>
                        </div>
                      </template>
                      <el-input
                        type="textarea"
                        :rows="2"
                        v-model="form.whitelist"
                        class="whitelistInput">
                      </el-input>
                    </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td colspan="2">
                    <el-form-item :label="$t('tableText.메모')" class="mb-0 formItem layerItem">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="form.mem_memo">
                        </el-input>
                     
                      </el-form-item>
                  </td>
                 
                </tr>
                              </table>
      
   


          </el-form>
          <div class="d-flex" style="justify-content: right;">
               <el-button type="primary" @click="Save" :disabled="disabled">{{$t('msg.수정')}}</el-button>
               <el-button type="danger" @click="Del" :disabled="disabled">{{$t('msg.삭제')}}</el-button>
                <el-button @click="Cancel">Close</el-button>
          </div>

                </el-tab-pane>
                 <el-tab-pane :label="$t('nav.로그인')" name="tab2">
                   <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')"  size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
    
                </div>

                  <el-table
                :data="tabList"
                 border
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading">

                <el-table-column
                  :label="$t('nav.아이디')" width="100" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  :label="$t('tableText.아이피')" align="center" prop="vIP">
                </el-table-column>

                <el-table-column
                  label="접속기기" width="90" align="center">
                  <template slot-scope="scope">
                    {{ getTerminalType(scope.row.vOS) }}
                  </template>
                </el-table-column>

                 <el-table-column
                 :label="$t('tableText.주소')"
                  align="center" prop="vReferer">
                </el-table-column>

                <el-table-column align="center" prop="add_time" :label="$t('tableText.시간')">
                </el-table-column>
               
              
              </el-table>
             
                 </el-tab-pane>

                  <el-tab-pane :label="$t('tableText.머니변동')"  v-if="form.sitetype=='4'" name="tab3">
                     <div class="d-flex" style="align-items:center;">
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                    
                  <div class="ml-2" v-if="this.userid=='admin'">
                   {{$t('msg.알충')}} :{{formatMoney(ain)}} <span class="ml-2">{{$t('msg.알환')}}:{{formatMoney(aout)}}</span>
                  </div>

                  <el-button v-if="this.userid=='admin'" type="primary" plain class="ml-auto" size="mini" @click="mtClick">{{$t('newAdd.게임사충환')}}</el-button>

       
    
                </div>
                      <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading">

               
               

                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"> <el-tooltip class="item" effect="dark" :content="scope.row.id"  placement="left"><el-button @click="del_id(scope.row.id)" type="text" style="padding:2px;">{{scope.row.mem_id}}</el-button></el-tooltip></template>
                </el-table-column>

                  <el-table-column
                    :label="$t('tableText.변동금액')"
                 width=100 align="center" prop="money">
                   <template slot-scope="scope"><span :class="scope.row.money < 0 ? 'text-danger' : ''">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.잔액')"
                   align="center" prop="new_money">
                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                </el-table-column>
               
              

                <el-table-column
                  prop="doc" align="center"
                  :label="$t('tableText.메모')">
                  
                  <template slot-scope="scope"><span>{{scope.row.doc}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')"
                 >
                  
                </el-table-column>
              </el-table>
                  </el-tab-pane>
                   

                   <el-tab-pane :label="$t('tableText.롤링변동')" v-if="form.sitetype=='4'" name="tab44">
                     <div class="d-flex align-items-center" >
                  <el-form inline ref="form" :model="idsearchform" >
                     <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.game_gubun"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions1"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                     
                       <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value4" :placeholder="$t('searchText.구분')" size="mini" style="width:80px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions4"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>

                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>


                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                   <div class="ml-2">{{$t('msg.롤링')}}:{{formatMoney(total_rog)}}</div>
       
    
                </div>

                      <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading">
             

               <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"> <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="left"><el-button @click="del_id(scope.row.id)" type="text" style="padding:2px;">{{scope.row.mem_id}}</el-button></el-tooltip></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.변동금액')" width=100 align="center" prop="money">
                   <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                 <el-table-column
                  :label="$t('tableText.잔액')" width=120
                   align="center" prop="new_event">
                   <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'"><span>{{ formatMoney(scope.row.new_event) }}</span></template>
                </el-table-column>


               
                <el-table-column
                  prop="type" width=100 align="center"
                  :label="$t('searchText.구분')"
                 >
                  <template slot-scope="scope"><span>{{typeObj[scope.row.type]}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="doc" align="center"
                  :label="$t('tableText.메모')"
                  >
                  
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center" width=150
                  :label="$t('tableText.시간')"
                >
                  
                </el-table-column>
              </el-table>
                  </el-tab-pane>
                   <el-tab-pane :label="$t('tableText.베팅롤링')" v-if="form.sitetype=='4'" name="tab444">
                     <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                     <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value" placeholder="구분" size="mini" style="width:100px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              start-placeholder="시작"
                              end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:300px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">검색</el-button>  
                      </el-form-item>

                  </el-form>
                  <div class="ml-2">배팅:{{formatMoney(total_money)}} <span class="ml-2 mr-2">당첨:{{formatMoney(total_emoney)}}</span> 롤링:{{formatMoney(total_rog)}}</div>
       
    
                </div>
                      <el-table
                :data="tabList"
                style="width: 100%;" v-loading="loading">


                <el-table-column
                  label="아이디"  align="center" prop="">
                   <template slot-scope="scope"><span>{{scope.row.mem_id}}</span></template>
                </el-table-column>

                  <el-table-column
                  label="변동금액"  align="center" prop="money">
                   <template slot-scope="scope"><span :class="func(scope.row.money)">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>


               
                <el-table-column
                  prop=""  align="center"
                  label="구분">
                  <template slot-scope="scope"><span>{{typeObj[scope.row.type]}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="" align="center"
                  label="메모">
                    <template slot-scope="scope"><span>{{scope.row.doc}}</span></template>
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  label="시간">
                  
                </el-table-column>

              </el-table>


                  </el-tab-pane>
                  <el-tab-pane :label="$t('tableText.내손익')" name="tab4">
                   
                    <el-tabs v-model="activeName7" @tab-click="handleClick7" type="card" class="mt-2">
      
                       <el-tab-pane  name="tab7-1">
                         <span slot="label">{{$t('msg.전체')}}</span>
                           <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <span class="mr-1 ml-1">{{$t('msg.하부포함')}}</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu"></el-checkbox> <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                border
                 :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt1)">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt2)">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="func(scope.row.tt12)">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


       <el-table-column 
        :label="$t('msg.총배팅')" prop="tt5" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt5)">{{ formatMoney(scope.row.tt5)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt5ca)">{{ formatMoney(scope.row.tt5ca)}}</span></template>
      </el-table-column>
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt5st)">{{ formatMoney(scope.row.tt5st)}}</span></template>
      </el-table-column>
    
      <el-table-column 
        :label="$t('msg.총배팅파')" v-if="this.power=='1'"  prop="tt5pa" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt5pa)">{{ formatMoney(scope.row.tt5pa)}}</span></template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총당첨')" prop="tt6" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt6)">{{ formatMoney(scope.row.tt6)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt6ca)">{{ formatMoney(scope.row.tt6ca)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt6st)">{{ formatMoney(scope.row.tt6st)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총당첨파')" v-if="this.power=='1'" prop="tt6pa" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt6pa)">{{ formatMoney(scope.row.tt6pa)}}</span></template>
      </el-table-column>

        <el-table-column
        :label="$t('msg.총수수료')" prop="tt7" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt7)">{{ formatMoney(scope.row.tt7)}}</span></template>
      </el-table-column>

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt7ca)">{{ formatMoney(scope.row.tt7ca)}}</span></template>
      </el-table-column>

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt7st)">{{ formatMoney(scope.row.tt7st)}}</span></template>
      </el-table-column>
      <el-table-column
        :label="$t('msg.총수수료파')" v-if="this.power=='1'" prop="tt7pa" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt7pa)">{{ formatMoney(scope.row.tt7pa)}}</span></template>
      </el-table-column>

       <el-table-column 
        :label="$t('msg.총수익')" prop="tt567" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt567)">{{ formatMoney(scope.row.tt567)}}</span></template>
      </el-table-column>

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt567ca)">{{ formatMoney(scope.row.tt567ca)}}</span></template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt567st)">{{ formatMoney(scope.row.tt567st)}}</span></template>
      </el-table-column>
      <el-table-column 
        :label="$t('msg.총수익파')" v-if="this.power=='1'" prop="tt567pa" align="center">
         <template slot-scope="scope"> <span :class="func(scope.row.tt567pa)">{{ formatMoney(scope.row.tt567pa)}}</span></template>
      </el-table-column>


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab7-2">
                         <span slot="label">{{$t('msg.카지노')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <span class="mr-1 ml-1">{{$t('msg.하부포함')}}</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu"></el-checkbox>
                        <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                 :row-class-name="tableRowClassName"
                border
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     

      <el-table-column 
        :label="$t('msg.총배팅카')" prop="tt5ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5ca)}}</template>
      </el-table-column>
     
    
   

    
      <el-table-column
        :label="$t('msg.총당첨카')" prop="tt6ca" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6ca)}}</template>
      </el-table-column>
 
  

     

      <el-table-column
         :label="$t('msg.총수수료카')"  prop="tt7ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7ca)}}</template>
      </el-table-column>

  
     

     

      <el-table-column 
        :label="$t('msg.총수익카')" prop="tt567ca" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567ca)}}</template>
      </el-table-column>
     
     


        
  
     
    </el-table>
                       </el-tab-pane>
                        <el-tab-pane  name="tab7-3">
                         <span slot="label">{{$t('msg.슬롯')}}</span>
                          <div class="d-flex" style="flex-direction:column">
                  <el-form inline ref="form" :model="idsearchform" >
                     
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time7"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <span class="mr-1 ml-1">{{$t('msg.하부포함')}}</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu"></el-checkbox>
                        <el-button type="info" size="mini" @click="idsearchEvent7" :loading="sLoading7">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>

                  </el-form>
                 
       
    
                </div>
                  <el-table
                :data="tabList"
                 :row-class-name="tableRowClassName"
                border
                style="width: 100%;" v-loading="loading7"
                show-summary
       :summary-method="getSummaries" class="memlistTable">
                <el-table-column
        
        :label="$t('tableText.날짜')" prop="date" align="center">
        
      </el-table-column>
    
    <el-table-column
        
        :label="$t('msg.충전')" prop="tt1" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt1)}}</span></template>
      </el-table-column>
     
      <el-table-column
        
        :label="$t('msg.환전')" prop="tt2" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt2)}}</span></template>
      </el-table-column>

       <el-table-column
        
        :label="$t('msg.충환')" prop="tt12" align="center">
         <template slot-scope="scope"><span :class="{'text-success' : scope.row.tt1 > 0,'text-danger' : scope.row.tt1 <0}">{{ formatMoney(scope.row.tt12)}}</span></template>
      </el-table-column>


     
  
      <el-table-column 
         :label="$t('msg.총배팅슬')" prop="tt5st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt5st)}}</template>
      </el-table-column>
    
   

     
      <el-table-column
        :label="$t('msg.총당첨슬')" prop="tt6st" width=120 align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt6st)}}</template>
      </el-table-column>
    

      

      <el-table-column
        :label="$t('msg.총수수료슬')"  prop="tt7st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt7st)}}</template>
      </el-table-column>
      
 

      
      <el-table-column 
        :label="$t('msg.총수익슬')" prop="tt567st" align="center">
         <template slot-scope="scope">{{ formatMoney(scope.row.tt567st)}}</template>
      </el-table-column>
    


        
  
     
    </el-table>
                       </el-tab-pane>
                     </el-tabs>
                  </el-tab-pane>

 <el-tab-pane  name="tab9" :label="$t('newAdd.수정이력')">
                   
                      
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent" :loading="sLoading">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                </div>

                
                      <el-table
                :data="tabList"
                 border
                  :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading">
               
              
                 
 <el-table-column
  :label="$t('newAdd.수정내용')"
  align="center"
  prop="doc"
>
  <template slot-scope="scope">
    <div style="width:350px; white-space: normal; word-break: break-all;">
      {{ scope.row.doc }}
    </div>
  </template>
</el-table-column>

                

                <el-table-column
                  prop="ip" align="center"
                  label="IP">
                </el-table-column>

                 <el-table-column
                  prop="add_time" align="center"
                  :label="$t('newAdd.수정시간')">  
                </el-table-column>

               
              </el-table>
           


                  </el-tab-pane>



                  <el-tab-pane :label="$t('msg.입출금')"  name="tab5">
                     <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                       <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value2"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                  <span class="ml-2">{{$t('msg.입금')}}:{{formatMoney(total_money)}} <span class="ml-2 mr-2">{{$t('msg.출금')}}:{{formatMoney(total_emoney)}}</span> {{$t('searchText.차액')}}:{{formatMoney(total_money-total_emoney)}}</span>
       
    
                </div>
                      <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-loading="loading">
                
                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="io_id">
                   <template slot-scope="scope"> <el-tooltip class="item" effect="dark" :content="scope.row.io_idx" placement="left"><el-button type="text" @click="del_idx(scope.row.io_idx)" style="padding:2px;">{{scope.row.io_id}}</el-button></el-tooltip></template>
                </el-table-column>

                 <el-table-column
                  :label="$t('searchText.구분')" 
                   align="center" prop="io_type">
                   <template slot-scope="scope">
                    <span class="text-danger" v-if="scope.row.io_type=='1'">{{$t('msg.입금')}}</span>
                    <span class="text-primary"v-if="scope.row.io_type=='2'">{{$t('msg.출금')}}</span>
                  </template>

                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')" 
                 align="center" prop="io_money">

                  <template slot-scope="scope"><span class="text-primary">{{ scope.row.io_type=='1' ? formatMoney(scope.row.io_money):formatMoney(scope.row.io_out_money)}}</span></template>

                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.이전잔액')" 
                align="center" prop="">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.io_jan)}}</span></template>
                   
                </el-table-column>


                <el-table-column
                  prop="io_regdate" align="center"
                  :label="$t('tableText.시간')" 
                 >
                  
                </el-table-column>
                
               
              
              </el-table>
                  </el-tab-pane>
                 

                  <el-tab-pane :label="$t('tableText.알충환')"  v-if="form.sitetype=='4'" name="tab6">
                     <div class="d-flex align-items-center">
                  <el-form inline ref="form" :model="idsearchform" >
                      <el-form-item  class="mb-0">
                      <el-select v-model="idsearchform.value3"  size="mini" style="width:90px;">
                           <el-option
                                  v-for="item in idsearchform.idsearchOptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                     <el-form-item  class="mb-0">
                     
                      </el-form-item>
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                             :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd"  style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
                   <span class="ml-2">{{$t('searchText.알충')}}:{{formatMoney(ain)}} </span>
                   <span class="ml-2 mr-2">{{$t('searchText.알환')}}:{{formatMoney(aout)}}</span>
                   <span>{{$t('searchText.차액')}}:{{formatMoney(ain-aout)}}</span>
       
    
                </div>
                      <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                style="width: 100%" v-loading="loading">
                
                <el-table-column
                :label="$t('nav.아이디')"
                  width=100 align="center" prop="mem_id">
                   <template slot-scope="scope"> <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="left"><el-button @click="del_al_id(scope.row.id,scope.row.buy_idx)" type="text" style="padding:2px">{{scope.row.mem_id}}</el-button></el-tooltip></template>
                </el-table-column>

                  <el-table-column
                  :label="$t('tableText.금액')" 
                  align="center" prop="money">
                   <template slot-scope="scope"><span :class="func(scope.row.money)">{{ formatMoney(scope.row.money)}}</span></template>
                </el-table-column>

                 <el-table-column
                 :label="$t('msg.내용')" 
                   align="center" prop="doc">
                </el-table-column>

                <el-table-column
                :label="$t('tableText.잔액')"
               align="center" prop="new_money">

                   <template slot-scope="scope"><span>{{ formatMoney(scope.row.new_money)}}</span></template>
                   
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  :label="$t('tableText.시간')"
                  >
                  
                </el-table-column>
                  
               
              
              </el-table>
                  </el-tab-pane>

                

                   <el-tab-pane :label="$t('tableText.배팅카슬')"  name="tab7">
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="datetimerange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd  HH:mm:ss" style="width:300px"  :default-time="['00:00:00','23:59:59']">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <el-select v-model="provider_name"  style="width: 150px;" class="ml-2 mr-2" size="mini" filterable >
                           <el-option
                                  v-for="item in providerlist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                         <span class="mr-1 ml-1">{{$t('msg.하부포함')}}</span>
                          <el-checkbox true-label="1" false-label="0" v-model="habu"></el-checkbox> 
                        <el-button type="info" size="mini" @click="idsearchEvent" :loading="sLoading">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                   <div v-if="this.form.sitetype=='4'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('msg.카')}}:{{formatMoney(total_money_e)}} {{$t('nav.슬')}}:{{formatMoney(total_money_slot)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('msg.카')}}:{{formatMoney(total_emoney_e)}} {{$t('nav.슬')}}:{{formatMoney(total_emoney_slot)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span><span class="text-secondary ml-4">슬공배팅:{{formatMoney(slot_gongbet)}}</span><span class="text-secondary ml-2">카공배팅:{{formatMoney(ca_gongbet)}}</span><span class="text-secondary ml-2">카타이:{{formatMoney(ca_tie)}}</span></div>

                   <div v-if="this.form.sitetype=='2'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span></div>
       
    
                </div>

                  <template v-if="this.form.sitetype=='4'">
                      <el-table
                :data="tabList"
                border
                :row-class-name="tableRowClassName"
                 @sort-change='tableSortChange'
                style="width: 100%;" v-loading="loading">


                 <el-table-column
                  :label="$t('nav.아이디')" align="center"  prop="username" width="100">
                </el-table-column>
               
                <el-table-column
                  :label="$t('nav.게임사')" align="center"  prop="provider_name" width="150">
                </el-table-column>
                 
                  <el-table-column
                  :label="$t('tableText.게임명')"
                   align="center" prop="game_title">
                </el-table-column>
                

                
                

                 <el-table-column
                  prop="bet" align="center" width=100 sortable="custom"
                  :label="$t('nav.배팅')">
                   <template slot-scope="scope">
                    <span :class="String(scope.row.total_loging) === '2' && (scope.row.type === 'Slots' || scope.row.game_type === 'Slots') ? 'text-danger' : 'text-info'">{{ formatMoney(scope.row.bet)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="win" align="center" width=100 sortable="custom"
                  :label="$t('msg.당첨')">
                    <template slot-scope="scope"> <span class="text-success">{{ formatMoney(scope.row.win)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="balance" align="center" width=100
                  :label="$t('msg.잔고')">
                    <template slot-scope="scope"> <span >{{ formatMoney(scope.row.balance)}}</span></template>
                </el-table-column>
                <el-table-column
                  prop="create_at" align="center" sortable="custom"
                  :label="$t('msg.일시')">
                </el-table-column>
                <el-table-column
                  prop="txid" align="center" width=80
                  :label="$t('msg.상세')">
                   <template slot-scope="scope">
        
                          <el-button type="primary" size="mini" @click="linkBtn(scope)" style="padding:2px;" plain>{{$t('msg.상세보기')}}</el-button>
 
                  </template>
                </el-table-column> 
              </el-table>
            </template>

                <template v-if="this.form.sitetype=='1'">
                                <el-table
                          :data="tabList"
                          border
                :row-class-name="tableRowClassName" @sort-change='tableSortChange'
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                           :label="$t('msg.회차')"
                           align="center"  prop="buy_num">
                          </el-table-column>
                           
                            <el-table-column
                             :label="$t('searchText.구분')"
                            align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                             :label="$t('nav.배팅')"
                            >

                             <template slot-scope="scope"><span :class="func(scope.row.buy_money)">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                             :label="$t('msg.배당')" sortable="custom">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                             :label="$t('msg.당첨')" sortable="custom">
                            <template slot-scope="scope"><span  :class="func(scope.row.buy_emoney)">{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')"
                           >
                            <template slot-scope="scope"><span  :class="func(scope.row.ocs)">{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')" >
                            <template slot-scope="scope"><span  :class="func(scope.row.c_m)">{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                             :label="$t('msg.일시')" sortable="custom">
                          </el-table-column>
                          
                        </el-table>
                        </template>

                  </el-tab-pane>
                     <el-tab-pane :label="$t('msg.배팅파워')" v-if="this.power=='1'"  name="tab8">
                     <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                               :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                            </el-date-picker>
                      </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>

                   <div v-if="this.form.sitetype=='4'" class="text-muted ml-1 mt-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('nav.단')}}:{{formatMoney(total_money_d)}} {{$t('nav.조')}}:{{formatMoney(total_money_z)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('nav.단')}}:{{formatMoney(total_emoney_d)}} :{{$t('nav.조')}}{{formatMoney(total_emoney_z)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}} ({{$t('nav.단')}}:{{formatMoney(total_money_d-total_emoney_d)}} :{{$t('nav.조')}}{{formatMoney(total_money_z-total_emoney_z)}})</span></div>

                 
       
    
                </div>

                  <template v-if="this.form.sitetype=='4'">
                      <el-table
                          :data="tabList"
                          border
                :row-class-name="tableRowClassName" @sort-change='tableSortChange'
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                            :label="$t('msg.회차')" align="center"  prop="buy_num">

                            <template slot-scope="scope"><span class="text-primary">{{ scope.row.game_type}} {{ scope.row.buy_num}}</span></template>


                          </el-table-column>
                           
                            <el-table-column
                            :label="$t('searchText.구분')" align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                              :label="$t('nav.배팅')">

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                            :label="$t('msg.배당')" sortable="custom">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                             :label="$t('msg.당첨')" sortable="custom">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                           :label="$t('msg.일시')" width="200" sortable="custom">
                          </el-table-column>
                          
                        </el-table>
            </template>

                <template v-if="this.form.sitetype=='1'">
                                <el-table
                          :data="tabList"
                          border
                           @sort-change='tableSortChange'
                :row-class-name="tableRowClassName"
                          style="width: 100%;"  v-loading="loading">
                         
                          <el-table-column
                            :label="$t('msg.회차')" align="center"  prop="buy_num">
                          </el-table-column>
                           
                            <el-table-column
                            :label="$t('searchText.구분')" align="center" prop="buy_gubun">
                          </el-table-column>
                          

                          <el-table-column
                            prop="buy_money" align="center"
                              :label="$t('nav.배팅')">

                             <template slot-scope="scope"><span class="text-primary">{{ formatMoney(scope.row.buy_money)}}</span></template>

                          </el-table-column>

                           <el-table-column
                            prop="buy_bedang" align="center"
                            :label="$t('msg.배당')" sortable="custom">  
                          </el-table-column>

                           <el-table-column
                            prop="buy_emoney" align="center"
                             :label="$t('msg.당첨')" sortable="custom">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.buy_emoney)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="ocs" align="center"
                             :label="$t('tableText.이전잔액')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.ocs)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="c_m" align="center"
                            :label="$t('msg.이전롤링')">
                            <template slot-scope="scope"><span >{{ formatMoney(scope.row.c_m)}}</span></template>
                          </el-table-column>
                          <el-table-column
                            prop="buy_time" align="center" 
                           :label="$t('msg.일시')" width="200" sortable="custom">
                          </el-table-column>
                          
                        </el-table>
                        </template>

                  </el-tab-pane> 
                   <el-tab-pane  name="tab9s">
                       <span slot="label"><i class="el-icon-chat-dot-square"></i>{{$t('msg.문의')}}</span>
                       <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                        <el-button type="danger" size="mini" @click="deleteAll9">{{$t('searchText.선택삭제')}}</el-button>
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')"  size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                       
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
    
                </div>

                 <el-table
      :data="tabList"
       v-loading="loading"
      style="width: 100%"
       :row-class-name="tableRowClassName"
      border class="mt-2" @selection-change="handleSelectionChange"   :empty-text="$t('tableText.데이타가없습니다')">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
    


        

     
     
      <el-table-column
        :label="$t('msg.문의제목')"
         prop="user_title" align="center">
        <template slot-scope="scope"><span @click="openModel(scope.row.id)" class="text-primary" style="cursor:pointer">{{scope.row.user_title}}</span><i class="ml-2 text-primary" :class="scope.row.mobile==='0' ? '':'el-icon-mobile'"></i></template>
      </el-table-column>


      <el-table-column
      prop="user_contents"  align="center"
      :label="$t('msg.문의내용')"  
      >
       <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="1"
            v-model="scope.row.user_contents"  @click.native="openModel(scope.row.id)">
          </el-input>
          </template>
      </el-table-column>
        

     

       <el-table-column
        
        label="IP" prop="ip" align="center">
      </el-table-column>

      

       <el-table-column
        :label="$t('tableText.처리시간')"
        prop="re_time" align="center" >
      </el-table-column>

       <el-table-column
       align="center"
      prop="status"
      :label="$t('tableText.처리상태')"
     >
      <template slot-scope="scope">
              <el-button type="text" @click="openModel(scope.row.id)"><span :class="colorObj[scope.row.status]">{{valObj[scope.row.status]}}</span></el-button>
          </template>
      </el-table-column>

    
    
      
  
     
    </el-table>
                
                    </el-tab-pane>
                      <el-tab-pane  name="tab10">
                       <span slot="label"><i class="el-icon-date"></i>{{$t('nav.종합로그')}}</span>
                       <div>
                  <el-form inline ref="form" :model="idsearchform" >
                    
                      <el-form-item  class="mb-0" style="margin-right:0">
                        <el-button type="danger" size="mini" @click="deleteAll10">{{$t('searchText.선택삭제')}}</el-button>
                         <el-date-picker
                              v-model="idsearchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                              :end-placeholder="$t('searchText.마감')"  size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px" >
                            </el-date-picker>
                      </el-form-item>
                         <el-form-item class="mb-0">
                         <el-select v-model="idsearchform.value10"  :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px;">
                           <el-option
                                  v-for="item in idsearchform.searchOptions10"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                      </el-form-item>
                

                    <el-form-item class="mb-0">
                         <el-input :placeholder="$t('searchText.키워드')" v-model="idsearchform.keyword10" size="mini" style="width:120px;"></el-input>
                    </el-form-item>
                      <el-form-item class="mb-0 mr-0">
                        <el-button type="info" size="mini" @click="idsearchEvent">{{$t('searchText.검색')}}</el-button>  
                      </el-form-item>
                  </el-form>
       
    
                </div>

                 <el-table
      :data="tabList"
       v-loading="loading"
      style="width: 100%"
       :row-class-name="tableRowClassName"
      border class="mt-2" @selection-change="handleSelectionChange"   :empty-text="$t('tableText.데이타가없습니다')">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{idtotal-(idcurrentPage-1)*50-scope.$index}}</template>
        </el-table-column>
       <el-table-column
       align="center"
      prop="userid" 
            :label="$t('nav.아이디')">
      <template slot-scope="scope">
            
             <span @click="openModel(scope.row.userid,'tab1')" class="text-primary" style="cursor:pointer">{{scope.row.userid}}</span>
          </template>
      
      </el-table-column>

            <el-table-column
           align="center"
            prop="admin_id"
            label="admin_id" v-if="this.userid=='admin'">
            
          </el-table-column>

      <el-table-column
        :label="$t('tableText.시간')"
        prop="add_date" align="center">
      </el-table-column>
    
      <el-table-column
      prop="contents"
             :label="$t('msg.내용')">
       <template slot-scope="scope">
              <el-input
            type="textarea"
            :rows="1"
            v-model="scope.row.contents">
          </el-input>
          </template>
      </el-table-column>
      
      
      <el-table-column
       align="center"
      prop="ip"
      label="IP">
      
      </el-table-column>
    
    
      
  
     
    </el-table>
               
                    </el-tab-pane>

                   
              </el-tabs>
             
              <div v-if="tapId !=='0'&& tapId !=='4'  " style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next,jumper"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>
         
        <el-dialog
            :visible.sync="dialogVisible" :width="getW" class="idModel" :modal="modelFalse"  top="5vh" >
            <div class="border-bottom py-3"><span class="text-danger" style="font-size:16px">{{this.form.mem_id}} ({{this.form.mem_name}})</span></div>
            <el-table
                :data="memIdData"
                style="width: 100%" v-loading="loading" class="memTable">
                <el-table-column
                  prop="date"
                  :label="$t('msg.날자')"
                  
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('msg.입금')"
                  >
                  <template slot-scope="scope">
                     {{formatMoney(scope.row.inm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="outm"
                  :label="$t('msg.출금')"
                  >
                   <template slot-scope="scope">
                     {{formatMoney(scope.row.outm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="inm"
                  :label="$t('searchText.차액')"
                  >
                  <template slot-scope="scope">
                     <span :class="scope.row.inm - scope.row.outm <0 ?'text-danger':'text-primary'">{{formatMoney(scope.row.inm - scope.row.outm)}}</span>
                  </template>
                </el-table-column>
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Close</el-button>
        
            </span>
          </el-dialog>
          <el-dialog
        
          :title="$t('searchText.쪽지보내기')" :width="customWidth" :modal="modelFalse" top="5vh"
          :visible.sync="creatModel">
           <div class="d-flex" v-loading="qaLoading">
          <div style="width:60%">
          <el-form ref="form" :model="memoform" label-width="60px" v-loading="loading" :rules="rules">
            
            <el-form-item :label="$t('nav.아이디')" class="mb-1">
              <el-input v-model="memoform.mem_id"></el-input>
            </el-form-item>
           
           <el-form-item :label="$t('msg.내용')" prop="content" class="mb-1">
               <el-input
                type="textarea"
                :rows="8"
                v-model="memoform.content">
              </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" class="float-right">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="memoSend()" class="float-right mr-2">{{$t('msg.확인')}}</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:38%;height:275px;overflow-y:auto;flex-direction:column;align-items:start">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title2}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
          <el-dialog
          :width="memWidth"
          :title="$t('msg.추천내역')" :modal="modelFalse"
          :visible.sync="reComModel"  top="5vh">
           <el-table
                :data="reComData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="mem_id"
                   :label="$t('msg.아이디닉네임')"
                  width="180">
                   <template slot-scope="scope">{{scope.row.mem_id}}({{scope.row.mem_name}}) {{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="mem_regdate"
                   :label="$t('msg.가입일')">
                  
                </el-table-column>
             
              </el-table>

         
          <span slot="footer" class="dialog-footer">
             <el-button @click="reComModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
          <el-dialog
          :title="$t('newAdd.게임사충환')"
          :visible.sync="mtcreatModel" :modal="modelFalse"  :width="getW">
           <el-table
                :data="kennData"
                style="" v-loading="mtLoad">
                <el-table-column
                  prop="username"
                   :label="$t('msg.아이디')"
                  width="" align="center">
                   
                </el-table-column>
                 <el-table-column
                  prop="amount"
                   :label="$t('tableText.금액')" align="center">
                    <template slot-scope="scope">
                    {{formatMoney(scope.row.amount)}}
                  </template>
                </el-table-column>
                 <el-table-column
                  prop="after"
                   :label="$t('tableText.잔액')" align="center">
                    <template slot-scope="scope">
                    {{formatMoney(scope.row.after)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="create_at"
                   :label="$t('tableText.시간')" align="center"  width="180">
                  
                </el-table-column>
              <el-table-column
                  prop="type"
                   :label="$t('searchText.구분')" align="center">
                    <template slot-scope="scope">
                   {{ktypeObj[scope.row.type]}}
                  </template>
                </el-table-column>
              </el-table>

        
          <span slot="footer" class="dialog-footer">
             <el-button @click="mtcreatModel = false">{{$t('msg.닫기')}}</el-button>
          
          </span>
        
       
       
        </el-dialog>
          <el-dialog
  
          :visible.sync="getModel" :modal="modelFalse"  :width="getW">
          
          <el-form ref="getform" :model="getform" v-loading="loading">
            <div class="d-flex">
               <div class="boxflex">
                   <h2>{{$t('msg.알잔액')}}</h2>
                   <p id="sitem">{{formatMoney(sitem)}} </p>
               </div>
               <div class="boxflex">
                   <h2>{{$t('msg.카슬머니')}}</h2>
                   <p id="apim">{{formatMoney(apim)}} </p>
               </div>
           </div>
            <div class="d-flex" style="width: 600px;">
               <el-form-item>
              <el-input v-model="getform.site_cash" size="mini" style="width: 100px;"></el-input>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
               <el-select v-model="getvalue" size="mini" style="width:140px;" @change="getChange($event,1)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
             
           
            <el-form-item class="getItem mb-0 ml-2">
              <span>-></span>
               <el-select v-model="getapim" size="mini" style="width:140px;" @change="getChange($event,2)">
               <el-option
                      v-for="item in getOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="getItem mb-0 ml-2">
              <el-button type="primary" size="mini" @click="submitGetm" :disabled="disabled">{{$t('msg.전환하기')}}</el-button>
            </el-form-item>
          </div>
          </el-form>
         
       
        </el-dialog>
  </div>
</template>
<script>
  import transaction from './transaction.vue';
 import qaDialog from './qa-dialog.vue';
import bettingDetails from './betting-details.vue';
import holdem from './holdem.vue';
 import layerchildnew from './layer-child-new.vue';
  import layerNew from './layer-new.vue';
 import layoutLayer from './layout-layer.vue';
  import playertransaction from './playertransaction.vue';
 import coupon from './coupon.vue';
const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];


  export default{
    components: {
    
      layerchildnew,layoutLayer,transaction,bettingDetails,holdem,coupon,layerNew,playertransaction,qaDialog
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      layerid:{
        type:String,
        default:""
      },
      lydata:{
        type:Object,
        default:()=>{
          return {}
        }
      },

      
      visible: {
                type: Boolean,
                default: false
            },
  
    formobject: {
        type: Object,
        default: () => {}
    },
   
    
    },
    computed: {
          
            idDialogVisible: {
                get() {
                    return this.visible
                },
            },
            
        },
      data(){
        return{
            colorObj:{
              '0':'text-danger',
              '1':'text-primary',
              '2':'text-success',
             
             
            },
            valObj:{
             '0':this.$i18n.t("msg.대기"),
              '1':this.$i18n.t("msg.완료"),
              '2':this.$i18n.t("msg.보류"),
             
             
            },
          habu:'1',
          prop:'',
          order:'',
          activeName7: 'tab7-1',
          sLoading7:false,
          loading7:false,
          providerlist:[
            {
                label:this.$i18n.t("status.선택"),
                value:''
            },
            ],
          provider_name:'',
          kennData:[],
          ktypeObj:{
            'add':this.$i18n.t("msg.충전"), 
            'sub':this.$i18n.t("msg.환전"), 
          },
            typeObj:{
              
              '1':this.$i18n.t("msg.배팅"), 
               '7':this.$i18n.t("msg.당첨"),
              '2':this.$i18n.t("msg.입금"),
              '3':this.$i18n.t("msg.출금"),
              '4':this.$i18n.t("msg.롤링전환"),
              '5':this.$i18n.t("msg.롤링지급"),
               '12':this.$i18n.t("msg.매장롤링"),
              '6':this.$i18n.t("msg.총판롤링"),
              '8':this.$i18n.t("msg.부본사롤링"),
              '9':this.$i18n.t("msg.회원롤링"),
              '10':this.$i18n.t("msg.알충전"),
              '11':this.$i18n.t("msg.알환전"),

               '13':this.$i18n.t("msg.롤링충전"),
              '14':this.$i18n.t("msg.롤링환전"),
             
              '21':this.$i18n.t("msg.사이트머니카지노머니전환"),
              '22':this.$i18n.t("msg.카지노머니사이트머니전환"),
 
            },
          total_emoney_e:'',
          total_emoney_slot:'',
           total_emoney:'',
          total_money:'',
           total_money_e:'',
          total_money_slot:'',
          slot_gongbet:'',
          ca_gongbet:'',
          ca_tie:'',
          total_rog:'',
           total_money_d:'',
            total_money_z:'',
             total_emoney_d:'',
              total_emoney_z:'',
              money:'',
              add_time:'',

           ain:'',
            aout:'',
           getW:'600px',
           mtLoad:false,
           sLoading:false,
           options1: [
               {
                label: this.$i18n.t("msg.가능"),
                 value: '0',
               
              }, {
                label: this.$i18n.t("msg.불가능"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.슬롯만"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.카지노만"),
                 value: '3',
               
              }],
           optionsApi: [{
              label: "SD",
              value: 'sd',
             
            } ,{
              label: this.$i18n.t("msg.오라클"),
               value: 'sp',
              
            }, {
              label: this.$i18n.t("msg.아너"),
               value: 'hn',
              
            }, {
              label: 'S밴더',
               value: 'ss',
              
            }, {
              label: this.$i18n.t("msg.세팅기준"),
               value: 'set',
              
            } ],
          getform:{
            site_cash:'',
          },
          getOptions:[
          {
              label:this.$i18n.t("msg.알잔액"),
              value:'sitem'
            },
            {
              label:this.$i18n.t("msg.카슬머니"),
              value:'apim'
            },
            
          ],
          options: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label:this.$i18n.t("msg.기본"),  
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
          getvalue:'sitem',
          getapim:'apim',
          apim:'',
          sitem:'',
          getModel:false,
          formLoading:false,
          modelFalse:false,
            idsearchform:{
            time:[],
            time7:[],
             idsearchOptions3:[
            {
              label:this.$i18n.t("msg.전체"),
              value:'1011'
            },
            {
              label:this.$i18n.t("msg.알충"),
              value:'10'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'11'
            },
           
            ],
            value3:'1011',
             searchOptions10:[
                
                    {
                    label:this.$i18n.t("nav.아이디"),
                    value:'mem_id'
                },
                 {
                    label:this.$i18n.t("tableText.아이피"),
                    value:'ip'
                },
                {
                    label:this.$i18n.t("msg.알본"),
                    value:'admin_id'
                },
            

                ],
               
            
                value10:'',
                  keyword10:'',
              idsearchOptions2:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.충전"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.알환"),
              value:'2'
            },
           
            ],
            value2:'',
             idsearchOptions:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'1'
            },
            {
              label:this.$i18n.t("msg.당첨"),
              value:'7'
            }


            ],
            value:'',

             idsearchOptions4:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.전환"),
              value:'2122'
            },
            {
              label:this.$i18n.t("msg.롤링"),
              value:'5'
            }


            ],
            value4:'',



             idsearchOptions1:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("searchText.카슬"),
              value:'api'
            },
           

            ],
            game_gubun:'',
          },
           pickerOptions: {
          },
           shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          idcurrentPage:1,
          idtotal:0,
          idsize:0,
          tabList:[],
          multipleSelection:[],
          tapId:'0',
          tabname:'',
          activeIndex: 'tab1',
          memWidth:'500px',
          customWidth:'800px',
          reComModel:false,
         qaLoading:false,
          creatModel:false,
          checkAll: false,
          mtcreatModel:false,
          qa:[],
          reComData:[],
          level: [],
          cities: checkboxsOptions,
          isIndeterminate: true,
          domain:window.sessionStorage.getItem('domain'),
          userid:window.sessionStorage.getItem('userid'),
          power:window.sessionStorage.getItem('power'),
          rosing:window.sessionStorage.getItem('rosing'),
          outbet:window.sessionStorage.getItem('outbet'),
          sim:window.sessionStorage.getItem('sim'),
          memIdData:[],
          dialogVisible: false,
          disabled:false,
          loading:false,
          memoform:{
            mem_id:'',
            content:'',
          },
          form:{
            api_join:'',
            user_type:'',
            mem_lev:'',
             memlist:[],
            pasing:'',
            trans_black:'',
            out_bet_power:'',
            out_bet_power_g:'',
            login_more:'0',
            api_money:0,
            power_cash:0,
            power_ecash:0,
            color:'',
            id_txt:'',
            bet_black:'',
            bet_black1:'',
            bet_black2:'',
            bet_black3:'',
            bet_black4:'',
            mem_name:'',
            mem_hp:'',
            mem_login:'',
            mem_id:'',
            mem_emoney:0,
            pasing:'',
            mem_pw:'',
            mem_bankcode:'',
            mem_banknum: '',
            mem_bankname:'',
            mem_jumin:'',
            mem_zip:'',
              ref:'',
            mem_regdate:'',
            mem_cash:'',
            mem_eventmoney:'',
            mem_ip:'',
            mem_raip:'',
            m_cp:'',
            mem_all_init:'',
             mem_all_e:'',
              mem_all_slot:'',
               mem_all_power:'',

            mem_memo:'',
            whitelist:'',
            mem_status:'',
            m_emoney:'',
            loging:'',
            logip:'',
            mem_login_date:'',
            a_code:'',
             m_code:'',
              s_code:'',
            last_money_date:'',
            in_money:'',
            out_money:'',
            reset_money:'',
            ca_gong:'',
            slot_gong:'',
            off_out:'',
            off_in:'',  
            event_loing:'',
            event_loing_recom:'',
            event_loing_group:'',
            event_loing_group_recom:'',
            event_loing_s:'',
            event_loing_recom_s:'',
            event_loing_group_s:'',
            event_loing_group_recom_s:'',

            event_loing1:'',
            event_loing_recom1:'',
            event_loing_group1:'',
            event_loing_group_recom1:'',
            event_loing_s1:'',
            event_loing_recom_s1:'',
            event_loing_group_s1:'',
            event_loing_group_recom_s1:'',



            event_boat_sambok: '',
            event_bokyeon: '',
            event_cycle_sambok: '',
            event_japan_sambok: '',
            event_japan_samsang: '',
            event_pro: '',
            event_pro_boat: '',
            event_pro_cycle: '',
            event_pro_japan: '',
            event_sambok: '',
            event_sang:'',


            event_loing_slot:'',
            event_loing_recom_slot:'',
            event_loing_e:'',
            event_loing_recom_e:'',

            last_out_money_date:'',
            reg_code:'',
            out_bet_power:'',
            out_bet_power_g:'',
            out_bet_sadari:'',
            out_bet_sadari_g:'',

           admin_id:'',

            b_code:'',
            pc_e:'',
            pc_slot:'',
            pc_p:'',
            mem_sms:'',
        

          },
          urlLink:'https://blackstone-hk1.ppgames.net/gs2c/parentRoundHistoryDetails.do?playSessionId=10845692434823&stylename=blst_diamond2&hash=4d2fd93804bd9de97a2096e3317f719a&language=KO',
          level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
            options: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label:this.$i18n.t("msg.기본"),  
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
          memState:'',
          mem_status:'1',
          m_emoney:'',
          statusoptions: [{
              label: this.$i18n.t("msg.정상"),
              value: '1',
             
            },{
              label: this.$i18n.t("msg.탈퇴"),
               value: '0',
             
            }],
             statusoptions3: [{
              label: this.$i18n.t("msg.금지"),
              value: '0',
             
            },{
              label: this.$i18n.t("msg.가능"),
               value: '1',
             
            }],
            statusoptions2: [
            {
              label: '300만',
              value: '3000000',
             
            },
            {
              label: '500만',
              value: '5000000',
             
            },{
              label: '1000만',
               value: '10000000',
             
            },{
              label: '2000만',
               value: '20000000',
             
            }],
              rules: {
                  
                  content:[{ required: true, message: '', trigger: 'blur'}],
                },

        
           
          
        }
      },

      created() {
        this.defaultDate();
         this.getProvide();
          // this.info.id父组件传给子组件的id值
          this.fetchManage(this.info.id);

          if(this.power=='1')
          {
                this.idsearchOptions1=[
                  {
                    label: this.$i18n.t("msg.전체"),
                    value:''
                  },
                  {
                    label: this.$i18n.t("searchText.카슬"),
                    value:'api'
                  },
                  {
                    label: this.$i18n.t("msg.파워볼"),
                    value:'power'
                  }
                ];
          }

          
             
    },
     computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
      
      methods:{
        mtClick(){
          this.mtcreatModel = true
          this.mtLoad = true
           let token=window.sessionStorage.getItem('user');

            let s_time="";
               let e_time="";

               let v=this.tapId;

                 let ttname=this.tabname;

               if(this.idsearchform.time!=null && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }



           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/get_apimoneylist?mem_id='+this.info.id+'&s_time='+s_time+'&e_time='+e_time,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                    this.mtLoad = false
                    console.log(response.data.data.DATA)
                    let data = response.data.data.DATA
                    this.kennData = data
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })
        },
         openModel(id){

           this.$layer.iframe({
                type: 2,
                title: '편집',
                content: {
                    content: qaDialog,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                 maxmin : true,

                shade: false,
                area: ['940px', '660px'],
               
            });
              
        },
          handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
         tableRowClassName({row, rowIndex}) {
    
       if (rowIndex%2 === 1) {
        return 'odd-row-class';
       }
       else{
         return 'edd-row-class';
       }
    },
          getTerminalType(userAgent){
            if (!userAgent) {
              return '-'
            }

            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(userAgent)
              ? '모바일'
              : 'PC'
          },
          handleClick7(tab, event){
         console.log(this.tapId)
          this.tabname=tab.name
           //   this.tapId='4'

              
               this.tabList=[];
                this.idcurrentPage=1
              this.getTablist7();

      },
       changeLabel(e){
      console.log(e)
      this.form.out_bet_power = e
    },
       func(state){
      if(state > 0){
        return "text-success"
      }else if(state <0){
         return "text-danger"
      }else if(state ===0){
         return ""
      }
    },
      playertransaction(id){
           this.$layer.iframe({
            type: 2,
            title: 'API내역',
            content: {
                content: playertransaction,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['750px', '300px'],
           
           
        });
        },
         deleteAll10(){
         this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.idx);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/log_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      }, 
     tableSortChange(column) {
 
         this.prop= column.prop
         this.order= column.order
         
        this.getTablist()
     },
       getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if(index === 0){
             sums[index] = this.$i18n.t("msg.합계");
          }
         else if (index === 1) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 2) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 3) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 4) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 5) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 6) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 7) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 8) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 9) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else if (index === 10) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 11) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 12) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 13) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 14) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 15) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 16) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 17) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 18) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }else if (index === 19) { 
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
               sums[index] = this.formatMoney(sums[index]);
            } else {
              sums[index] = '/';
            }
          }
          else {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '/';
            }
          }
        });
        return sums;
      },
        getTablist7(){
               let s_time="";
               let e_time="";

               // let v=this.tapId;

               let ttname=this.tabname;

             console.log(ttname)



                if(this.idsearchform.time7!=null && this.idsearchform.time7.length>0)
               {
                  s_time=this.idsearchform.time7[0];
                  e_time=this.idsearchform.time7[1];
               }



           
             

             let token=window.sessionStorage.getItem('user');
             let urls='';
            
             if(ttname=="tab7-1")
             {
                urls=this.domain+'/admin/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=all'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&habu=1';
             }
             else if(ttname=="tab7-2")
             {
                urls=this.domain+'/admin/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=live'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&habu=1';
             }
              else if(ttname=="tab7-3")
             {
                urls=this.domain+'/admin/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&habu=1';
             }else if(ttname=="tab4")
             {
                urls=this.domain+'/admin/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=slot'+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&habu=1';
             }else
             {
               console.log("else getTablist7")
               return;
             } 


             this.loading7 = true
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('tabdata7=',response.data)
                     let data = response.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data


                     this.loading7 = false
                     this.sLoading7 = false

                   
               
            }).catch((error) =>{
               this.loading7 = false
               
            })
        },
         idsearchEvent7(){
       // this.sLoading7  =true
        this.getTablist7();
        },
         tableRowClassName({row, rowIndex}) {
    
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
getProvide(){
        let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/get_provider',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              console.log('providelist',response.data)
           let newids=[];


           let obj={};
            obj.label='전부'
            obj.value=''
            newids.push(obj);     


            response.data.data.forEach(item=>{
             obj={};
            obj.label=item.provider_name
            obj.value=item.provider_name
            newids.push(obj);            
           });


           

           this.providerlist=newids
    
            }).catch((error) =>{
              
            })

    },
        getList(){
         this.fetchManage(this.info.id);

        },

          bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['540px', '480px'],
        });
        
        },
          couponOpen(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: coupon,
                parent: this,
                data:{
                
                info:{id:id,},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['520px', '550px'],
        });
        
        },
        
         openId(id){
          let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
           this.$layer.iframe({
            type: 2,
            title: id,
            content: {
                content: layerNew,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
               area: [width+'', '700px'],
           
        });
        
        },

         del_id(id){
    
          if(this.userid=='admin')
          {

              this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


          let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/admin/moneylogs_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })

            }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

            
          }
         },
         del_idx(id){
    
          if(this.userid=='admin')
          {

            this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


           let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/admin/raceinout_del',
                        data:{
                          idx:[id],     
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })
                  

           }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });


           
          }
         },

           del_al_id(id,buy_id){
    
          if(this.userid=='admin')
          {

            this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {


           let token=window.sessionStorage.getItem('user');
                 this.$axios({
                        method:'post',
                        url:this.domain+'/admin/moneyinout_del',
                        data:{
                          idx:[id],
                          bidx:[buy_id],
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                               message:response.data.msg,
                                type: 'warning'
                               });
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                            }
                         
                     
                  }).catch((error) =>{
                      
                  })
                  

           }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });


           
          }
         },


        getChange(v,type){
           var objVal = {}
              
             if(type=='1')
             {
                 if(v=='sitem')
                 {
                     this.getapim="apim"
                 }
                 if(v=='apim')
                 {
                     this.getapim='sitem'
                 }
             }
             if(type=='2')
             {
                 if(v=='sitem')
                 {
                     this.getvalue='apim'
                 }
                 if(v=='apim')
                 {
                     this.getvalue='sitem'
                 }
             }

              console.log(v)
              console.log(type)


        },
       
        submitGetm(){
          this.disabled = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/admin/exchange_gm_apim',
                  data:{
                    mem_id:this.form.mem_id,
                    cash:this.getform.site_cash,
                    type:this.getvalue
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false

                      if(response.data.code==200)
                            {
                                         this.$message.success(response.data.msg);
                                         this.getModel=false
                                         this.form.api_money = response.data.api_money
                                         this.form.mem_cash = response.data.mem_cash
                                        // this.form.api_money = response.data.apimoney
                                        
                            }else
                            {
                                         this.$message.error(response.data.msg);
                            }

                             this.disabled = false
                 
        
                    }).catch((error) =>{  

                       this.disabled = false

                      console.log('error',error.response)
                     
                   })
        },
         getm(){
          this.getModel=true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getm?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
        
                }).then((response) =>{ 
                  this.loading = false
                    console.log(response.data.data)
                  let data = response.data.data
                   this.apim = data.apimoney
                   this.sitem = data.gamemoney
        
                    }).catch((error) =>{  

                      console.log('error',error.response)
                     
                   })

         },
          fetchManage(id){
            this.formLoading = true
            let token=window.sessionStorage.getItem('user');
            let that=this
            this.$axios({
                  method:'get',
                 
                   url:this.domain+'/admin/mem?fit='+this.prop+'&order='+this.order+'&mem_id='+id,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false
                   let data = response.data.data
               
                   this.form = {
                    user_type:data.user_type,
                    trans_black:data.trans_black,
                     pasing: data.pasing,
                    admin_id: data.admin_id,
                      id_txt: data.id_txt,
                      bet_black : data.bet_black,
                      sitetype:data.sitetype,
                      bg:this.bg,
                      ref:data.ref,
                      color:data.RaceYN,
                      mem_ing:data.mem_ing,
                      mem_name:data.mem_name,
                      api_money:data.api_money,
                      power_cash:data.power_cash,
                      power_ecash:data.power_ecash,
                      mem_emoney:data.mem_emoney,
                      mem_hp:data.mem_hp,
                      mem_login:data.mem_login,
                      mem_id:data.mem_id,
                      mem_pw:data.mem_pw,
                      mem_bankcode:data.mem_bankcode,
                      mem_banknum: data.mem_banknum,
                      mem_bankname:data.mem_bankname,
                      event_boat_sambok : data.event_boat_sambok,
                      event_bokyeon : data.event_bokyeon,
                      event_cycle_sambok : data.event_cycle_sambok,
                      event_japan_sambok : data.event_japan_sambok,
                      event_japan_samsang : data.event_japan_samsang,
                      event_pro : data.event_pro,
                      event_pro_boat : data.event_pro_boat,
                      event_pro_cycle : data.event_pro_cycle,
                      event_pro_japan : data.event_pro_japan,
                      event_sambok : data.event_sambok,
                      event_sang : data.event_sang,
                      login_more : data.login_more,
                      mem_jumin:data.mem_jumin,
                      mem_email:data.mem_email,
                      mem_zip:data.mem_zip,
                      mem_regdate:data.mem_regdate,
                      mem_cash:data.mem_cash,
                      max_bet:data.max_bet,
                      m_emoney:data.m_emoney,
                      bet_black1 : data.bet_black1,
                      bet_black2 : data.bet_black2,
                      bet_black3 : data.bet_black3,
                      bet_black4 : data.bet_black4,
                      t_delay:data.t_delay,
                      mem_eventmoney:data.mem_eventmoney,
                      mem_ip:data.mem_ip,
                      mem_raip:data.mem_raip,
                      m_cp:data.m_cp,
                      mem_all_init:data.mem_all_init,
                      mem_all_e:data.mem_all_e,
                      mem_all_slot:data.mem_all_slot,
                      mem_all_power:data.mem_all_power,
                      mem_memo:data.mem_memo,
                      whitelist:data.whitelist || '',
                      mem_lev:data.mem_lev,
                      memlist:data.memlist,
                      mem_status:data.mem_status,
                      memState:data.memState,
                      loging:data.loging,
                      logip:data.logip,
                      mem_login_date:data.mem_login_date,
                      a_code:data.a_code,
                      m_code:data.m_code,
                      s_code:data.s_code,
                      last_money_date:data.last_money_date,
                      in_money:data.in_money,
                      out_money:data.out_money,
                      reset_money:data.reset_money,
                      ca_gong:data.ca_gong,
                      slot_gong:data.slot_gong,
                      off_in:data.off_in,
                      off_out:data.off_out,
                      event_loing:data.event_loing,
                      event_loing_recom:data.event_loing_recom,
                      event_loing_group:data.event_loing_group,
                      event_loing_group_recom:data.event_loing_group_recom,
                      event_loing_s:data.event_loing_s,
                      event_loing_recom_s:data.event_loing_recom_s,
                      event_loing_group_s:data.event_loing_group_s,
                      event_loing_group_recom_s:data.event_loing_group_recom_s,
                      event_loing1:data.event_loing1,
                      event_loing_recom1:data.event_loing_recom1,
                      event_loing_group1:data.event_loing_group1,
                      event_loing_group_recom1:data.event_loing_group_recom1,
                      event_loing_s1:data.event_loing_s1,
                      event_loing_recom_s1:data.event_loing_recom_s1,
                      event_loing_group_s1:data.event_loing_group_s1,
                      event_loing_group_recom_s1:data.event_loing_group_recom_s1,
                      event_loing_recom_e:data.event_loing_recom_e,
                      event_loing_recom_slot:data.event_loing_recom_slot,
                      event_loing_e:data.event_loing_e,
                      event_loing_slot:data.event_loing_slot,
                      c_code:data.c_code,
                      last_out_money_date:data.last_out_money_date,
                      reg_code:data.reg_code,
                      out_bet_power:data.out_bet_power,
                      out_bet_power_g:data.out_bet_power_g,
                      out_bet_sadari:data.out_bet_sadari,
                      out_bet_sadari_g:data.out_bet_sadari_g,
                      b_code:data.b_code,
                      pasing:data.pasing,
                      mem_sms:data.mem_sms,
                      pc_e:this.formatMoney(data.pc_e),
                      pc_slot:this.formatMoney(data.pc_slot),
                      pc_p:this.formatMoney(data.pc_p),
                      api_join:data.api_join,
                    }

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
      },
          handleTabClick(tab, event) {
              
                this.tabname=tab.name
                this.tapId=tab.index

                if(tab.name=='tab7')
                {
                     this.provider_name='';
                }

             
                this.tabList=[];
                this.idcurrentPage=1
                this.getTablist();   
      },
      idsearchEvent(){
        this.sLoading  =true
         this.idcurrentPage=1
        this.getTablist();
        },

         qaChange(index){
         
         
         
          this.memoform.content = this.qa[index].contents
 
        },
        addRcom(){
          this.reComModel = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                  method:'get',
                   url:this.domain+'/admin/mem?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.loading = false
                   let data = response.data.data
                   console.log('recom:',data.recom)
                   this.reComData = data.recom
                  
              
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
        linkBtn(e){

           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getGameCategory?provider_name='+e.row.provider_name+'&opcode='+e.row.opcode+'&admin_id='+e.row.admin_id+'&dd='+e.row.create_at+'&user_id='+e.row.user_id+'&username='+e.row.username+'&ping='+e.row.ping+'&round_id='+e.row.round_id+'&txid='+e.row.txid,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 

             if ( response.data.code == "500")
             {
                 alert(response.data.msg);
             }
             else if(response.data.code=="100"){
              
                   let bets=response.data.data.data.data.participants[0].bets;
              let newbet1=[];
              let newbet2=[];
              let newbet3=[];
              let newbet4=[];

              let modifiedArr = bets.map(function(element){
                 if(element["code"].indexOf("Banker")>0)
                 { 
                      newbet1.push(element);
                 }
                 if(element["code"].indexOf("Player")>0)
                 { 
                      newbet2.push(element);
                 }
                 if(element["code"].indexOf("Tie")>0)
                 { 
                      newbet3.push(element);
                 }
                 if(element["code"].indexOf("Etc")>0)
                 { 
                      newbet4.push(element);
                 }
                 
                 
              });
              console.log('newbet1',newbet1)

                 
                  this.$layer.iframe({
                    type: 2,
                    title: e.row.username+' '+e.row.create_at,
                    content: {
                        content: transaction,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        BAC_Banker:newbet1,
                        BAC_Player:newbet2,
                        BAC_Tie:newbet3,
                        BAC_Etc:newbet4,
                        outcome:response.data.data.data.data.result.outcome,
                        banker_cards:response.data.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.data.result.player.cards,
                        banker:{score:response.data.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.data.result.player.score},
                        dealer:{name:response.data.data.data.data.dealer.name},
                        table:{name:response.data.data.data.data.table.name},
                        gameProvider:response.data.data.data.data.gameProvider,
                        totalStake:response.data.data.data.data.totalStake,
                        totalPayout:response.data.data.data.data.totalPayout,
                        gameType:response.data.data.data.data.gameType,
                        status:response.data.data.data.data.status,
                        settledAt:response.data.data.data.data.settledAt,
                        skin: 'layer_bg',
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['830px', '850px'],
                 
                });

             }
             else if(response.data.code=="300"){
              console.log(response.data.mem_id)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                        banker_cards:response.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.result.player.cards,
                        outcome:response.data.data.data.result.outcome,
                        banker:{score:response.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.result.player.score},
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="301"){


               if(typeof(response.data.data.detail.data.result.banker) == "undefined")
               {

                var data = response && response.data && response.data.data || {}
                var detailData = data.detail && data.detail.data || {}
                var result = detailData.result || {}

                   this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                       
                        
                        result: result,

                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                  });
                   return;
               }

               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                        banker_cards:response.data.data.detail.data.result.banker.cards,
                        player_cards:response.data.data.detail.data.result.player.cards,
                        outcome:response.data.data.detail.data.result.outcome,
                        banker:{score:response.data.data.detail.data.result.banker.score},
                        player:{score:response.data.data.detail.data.result.player.score},
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="302"){
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                        banker_cards:response.data.data.result.banker.cards,
                        player_cards:response.data.data.result.player.cards,
                        outcome:response.data.data.result.outcome,
                        banker:{score:response.data.data.result.banker.score},
                        player:{score:response.data.data.result.player.score},
                        bets:response.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="303"){
            
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                       
                        
                        
                        bets:response.data.data.details.bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="400"){
              console.log(response.data.data.data)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else
             {
                 window.open(response.data.data,'_blank')
             }
                 
                 
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          console.log(e);

          //window.open(this.urlLink,'_blank')
        },
        memoSend(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
           
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/memo_send',
                        data:{
                          content:this.memoform.content,
                          mem_id:this.memoform.mem_id,
                          level:this.level,
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                              
                            
                            this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            })
              
            
        },
        add(){

             console.log('test')
             let token=window.sessionStorage.getItem('user');
             this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqalist?type=memo',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //console.log('data====',response.data.data)
                  let item = response.data.data 
                  //this.form.content=''
                  this.qa = item
                  this.memoform.content=''
                  this.memoform.mem_id=this.form.mem_id
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          this.creatModel = true

        },
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
        memModel(){
          this.getData()
          this.dialogVisible = true
          this.loading = true
        },
          getTablist(){
               let s_time="";
               let e_time="";
               let s_time7="";
               let e_time7="";
               let v=this.tapId;

                 let ttname=this.tabname;

               if( this.idsearchform.time!=null && this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }
               else if(this.idsearchform.time7!=null && this.idsearchform.time7.length>0){
                 s_time7=this.idsearchform.time7[0];
                  e_time7=this.idsearchform.time7[1];
               }else
               {

               }


            if(v=="0")
            {
              this.fetchManage(this.info.id);
              return
            }
             this.loading = true
              this.loading7 = true
             let token=window.sessionStorage.getItem('user');
             let urls='';
             if(ttname=="tab2")
             {
                urls=this.domain+'/admin/acclist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab3")
             {
                urls=this.domain+'/admin/moneylogs_id?log=1&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab444")
           {
             urls=this.domain+'/admin/moneylogs_id?type='+this.idsearchform.value+'&log=0&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(ttname=="tab4")
             {
              urls=this.domain+'/admin/calculation_new?xia=1&mem_id='+this.form.mem_id+'&gubun=all'+'&page='+this.idcurrentPage+'&s_time='+s_time7+'&e_time='+e_time7;
             }else if(ttname=="tab44")
             {
               urls=this.domain+'/admin/moneylogs_id?game_gubun='+this.idsearchform.game_gubun+'&type='+this.idsearchform.value4+'&log=2&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }
             else if(ttname=="tab5")
             {
               urls=this.domain+'/admin/moneylist_id?io_type='+this.idsearchform.value2+'&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab6")
             {
               urls=this.domain+'/admin/moneylogs_id?type=1011&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
             }else if(ttname=="tab7")
             { 


                 if(this.form.sitetype=='4')
                 {
                    urls=this.domain+'/admin/apibetlist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&provider_name='+this.provider_name+'&fit='+this.prop+'&order='+this.order+'&habu=1';
                 }
                 if(this.form.sitetype=='1')
                 {
                    urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage+'&provider_name='+this.provider_name+'&fit='+this.prop+'&order='+this.order+'&habu=1';  
                 }
             
           
           }else if(ttname=="tab8")
           { 

             if(this.form.sitetype=='4')
             {
                urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage+'&fit='+this.prop+'&order='+this.order;  
             }
             if(this.form.sitetype=='1')
             {
                urls=this.domain+'/admin/betlist?mem_id='+this.form.mem_id+'&game_code=&buy_good=&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage+'&fit='+this.prop+'&order='+this.order;  
             }
             
           
           }else if(ttname=="tab9")
             { 

           
                urls=this.domain+'/admin/mchangelist?mem_id='+this.form.mem_id+'&s_time='+s_time+'&e_time='+e_time+'&page='+this.idcurrentPage;  
             
             
           
           }else if(ttname=="tab9s")
             { 

           
              
               urls=this.domain+'/admin/qalist?user_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&status=';
             
           
           }
           else if(ttname=="tab10")
           { 

            urls=this.domain+'/admin/loglist?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time+'&'+this.idsearchform.value10+'='+this.idsearchform.keyword10;
             
           
           }

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 


              if(response.data.code!=200)
              {
                  this.$message({
                          message:response.data.msg,
                          type:'error'
                      })  

                     this.loading = false
                     this.sLoading = false
                      this.loading7 = false
                      this.sLoading7 = false

                  return;
              }

                      
                     console.log('tabdata=',response.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                      if(ttname=="tab4")
                     {
                        this.tabList =data
                        this.loading7 = false
                        this.sLoading7 = false

                       
                        return;
                     }

                      if(ttname=="tab9s")
                     {

                      console.log(data.data)
                        this.tabList =data.data
                          this.loading = false
                     this.sLoading = false
                      this.loading7 = false
                      this.sLoading7 = false

                       
                        return;
                     }

                     
                     this.tabList =data.data

                     this.ain = response.data.ain
                     this.aout = response.data.aout

                     this.total_emoney = response.data.total_emoney
                     this.total_rog = response.data.total_rog
                     this.total_money = response.data.total_money
                      this.total_money_e = response.data.total_money_e
                      this.total_money_slot = response.data.total_money_slot
                      this.slot_gongbet = response.data.slot_gongbet || data.slot_gongbet || 0
                      this.ca_gongbet = response.data.ca_gongbet || data.ca_gongbet || 0
                      this.ca_tie = response.data.ca_tie || data.ca_tie || 0
                      this.total_emoney_e = response.data.total_emoney_e
                     this.total_emoney_slot = response.data.total_emoney_slot

                      this.total_money_d = response.data.total_money_d
                     
                      this.total_money_z = response.data.total_money_z

                       this.total_emoney_d = response.data.total_emoney_d
                     
                      this.total_emoney_z = response.data.total_emoney_z
                   

                     this.loading = false
                     this.sLoading = false
                      this.loading7 = false
                      this.sLoading7 = false

                   
               
            }).catch((error) =>{
                 this.loading = false
                     this.sLoading = false
                      this.loading7 = false
                      this.sLoading7 = false
               
            })
        },
         deleteAll9(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/qa_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
         idhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
               this.idsize = val
              this.getTablist();
              this.loading= true

            },
            idhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.idcurrentPage = val
              this.getTablist();
              this.loading= true
            },
        getData(){
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/mem_by_inout_date?mem_id='+this.form.mem_id;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('data=',response.data)
                     let data = response.data.data
                     this.memIdData =data
                     let inmoney=0;
                     let outmoney=0;
                     data.map(function(item)
                     {
                        inmoney+=parseInt(item.inm)
                        outmoney+=parseInt(item.outm)
                     })

                     let total={date: "total", inm: inmoney, outm: outmoney};

                     this.memIdData.push(total);
                     this.loading = false

                   
               
            }).catch((error) =>{
              // if(error.response.status==401)
              // {
              //   this.$router.push({name:'login'})

              // }
                console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
         defaultDate() {
                  var date = new Date()
                  var year = date.getFullYear().toString()
                  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
                  var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
                  // var da = new Date(date.getFullYear(), month, 0).getDate()
                  da < 10 ? '0' + da.toString() : da.toString()
                  var beg = year + '-' + month + '-01'
                  var end = year + '-' + month + '-' + da
                  this.idsearchform.time7 = [beg, end] 
                  console.log('time',beg)
                },

        Cancel(){
           this.$layer.close(this.layerid);
        },

      
        Save(){
           this.$confirm(this.$i18n.t("msg.수정하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.수정"),
          cancelButtonText: this.$i18n.t("msg.취소"),
         
          type: 'warning'
        }).then(() => {
          this.disabled = true
              this.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_up',
                      data:this.form,   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                   // console.log('response',response);

                   if(response.data.code==200){
                       this.disabled = false
                       this.formLoading = false
                     //  this.$layer.close(this.layerid);
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      this.disabled = false
                      this.$parent.formLoading = false
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨"),
          });          
        });
              
     
        },

         Del(){
           this.$prompt(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
             confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
           inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
         
          type: 'warning'
        }).then(({ value }) => {
          this.disabled = true
              this.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_del?opt='+value+'&mem_id='+this.form.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                    this.disabled = false
                       this.formLoading = false
 this.$parent.formLoading = false

                   if(response.data.code==200){
                      
                       this.$layer.close(this.layerid);
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      
                     
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨"),
          });          
        });
              
     
        },
         apiMoney(type){
            
        
          let token=window.sessionStorage.getItem('user');
          let that=this;
          this.$axios({
                      method:'get',
                      url:this.domain+'/admin/getapimoney?mem_id='+this.form.mem_id,
                     
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                  
                    if(response.data.code==200){

                       this.$message({
                      message:this.$i18n.t("msg.갱신완료"),
                      type:'success'
                    })
                     
                      that.form.api_money=response.data.data
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      
                  })
        },

          resetMoney(type){
            let mtype='';
                     if(type==1)
                      {
                        mtype=this.$i18n.t("msg.게임머니");
                      }
                      else if(type==2)
                      {
                     
                       mtype=this.$i18n.t("msg.이벤트머니"); 
                        
                      }
                      else if(type==3)
                      {
                        mtype=this.$i18n.t("msg.롤링머니");
                      }
                      else if(type==4)
                      {
                        mtype=this.$i18n.t("msg.배팅누적");
                      }


          this.$confirm(mtype+this.$i18n.t("msg.리셋하시겠습니까"), this.$i18n.t("msg.알림"),{
            confirmButtonText: this.$i18n.t("msg.취소"),
          cancelButtonText: this.$i18n.t("msg.리셋"),
      
       
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/reset_money',
                      data:{
                      mem_id:this.form.mem_id,
                      type:type
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      if(type==1)
                      {
                       this.form.mem_cash = '0'
                      }
                      else if(type==2)
                      {
                       this.form.mem_eventmoney='0'
                        
                        
                      }
                      else if(type==3)
                      {
                       this.form.mem_ing='0'
                      }
                      else if(type==4)
                      {
                       this.form.mem_all_init='0'
                      }
                      
                     
              
                      //this.$parent.getList()
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:  this.$i18n.t("msg.취소됨"),
          });          
        });

     
        },
        mlogout(){
          
                     


          this.$confirm(this.form.mem_id+this.$i18n.t("msg.아웃하시겠습니까"), this.$i18n.t("msg.알림"), {
           confirmButtonText: this.$i18n.t("msg.아웃"),
          cancelButtonText: this.$i18n.t("msg.취소"),
            
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_out',
                      data:{
                      mem_id:this.form.mem_id
                      
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                       this.form.loging='0'
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$i18n.t("msg.취소됨")
          });          
        });

     
        },
        
        handleClose() {
                this.$emit('handleClose')
            },

      
      }
  }
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item{
  color: #333 !important;font-weight: bold;
}
.el-tabs--border-card>.el-tabs__header{
    background-color:#e4e5e6 !important;
  }
.el-tabs--card>.el-tabs__header .el-tabs__item{
   background-color:#e4e5e6;
}
.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  background-color:#fff
}
.el-tabs--border-card>.el-tabs__content{
  padding:5px;
}
/deep/ .el-dialog__body{
  padding:5px 10px;
}
/deep/ .el-dialog__header{
  padding:2px 20px 10px
}
.flexNo{
  display: block;
}
.myflex{
  margin-left: -80px;
}
>>>.el-tabs__header{
  margin-bottom: 5px;
}.boxflex {
  
    color: #3d3a3a;
    border: 1px solid #f1f1f1;
    width: 98%;
    text-align: center;
    margin-bottom: 10px;
  
}

.boxflex h2 {
    color: #2c2b2b;
    font-size: 14px;
    background-color: #e4e4e4;
    height: 32px;
    line-height: 32px;
}
.el-radio__inner{border:1px solid #747475 !important}
.el-radio__label{padding-left:5px !important}
.whitelistItem .el-form-item__content {
  line-height: 1;
}
.whitelistInput {
  width: 420px;
  max-width: 100%;
}
.whitelistInput .el-textarea__inner {
  min-height: 42px !important;
  height: 42px;
  padding: 5px 8px;
  resize: vertical;
  color: #1f4d72;
  background-color: #f4f9ff;
  border-color: #9bc2e6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/layer-new.vue